<template>
    <ContentWrapper>
        <div>
            <div class="d-flex">
                <input type="text" v-model="newCatName" class="form-control mr-3" name="anniversary" style="width:calc(100% - 73px)">
                <b-button-group>
                    <button @click="save()" class="btn btn-primary mb-2">추가</button>
                </b-button-group>
            </div>
            <div class="card card-default book-list">
                <div class="card-body" style="background-color:#fff;">
                    <table class="table table-striped table-hover card-body text-center">
                        <thead>
                            <tr>
                                <td colspan="2">분류유형</td>
                            </tr>
                        </thead>
                        <tr v-for="item in  data.list" :key="item.categoryName">
                            <td class="align-middle text-left">{{item.categoryName}} </td>
                            <td class="text-right">
                                <b-button-group>
                                    <button @click="remove(item.seq)" class="btn btn-secondary  mb-2">삭제</button>
                                </b-button-group>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
       </div>
   </ContentWrapper>
</template>
<script>
import Vue from 'vue'
import { reactive, ref, computed, onMounted, onUnmounted ,onBeforeMount} from '@vue/composition-api'
import {dataObject} from "@/utils/Constants";
import {getBoardCatList,setBoardCatList, deleteBoardCatList} from "@/api/notice/BoardCatApi";
import {getSsoAdmList} from "@/api/sso/SsoAdmApi";
import Pagenation from "@/components/Common/Pagenation";
import {TableActionClass} from "@/utils/TableActionClass";
import swal from 'sweetalert2'
import Axios from 'axios';

// 로딩처리
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

import draggable from 'vuedraggable'
// 목차/차시/파일

import VueQuillEditor from 'vue-quill-editor'

import 'quill/dist/quill.core.css' // import styles
import 'quill/dist/quill.snow.css' // for snow theme
import 'quill/dist/quill.bubble.css' // for bubble theme

Vue.use(VueQuillEditor, /* { default global options } */)

export default {
  props: {
      catType : '',
  },
  components: { Pagenation,  Loading},

  setup(props,context){
    const _dataObject = _.cloneDeep(dataObject);
    const data = reactive(_dataObject);

    const newCatName = ref('');
    const newCatType = props.catType;

    const loadData = async () => {
      let result = await getBoardCatList(props.catType);
      data.list = result.data;
      data.count = result.data.length;
    }

    const save = async() => {
      let params = {
        categoryType : newCatType,
        categoryName : newCatName.value,
      }
        let result = await setBoardCatList(params);
        if(result.data){
            alert("추가되었습니다.");
            let result = await getBoardCatList(newCatType);
            data.list = result.data;
            data.count = result.length;
            context.emit('refresh');
            newCatName.value = '';
        }
    }

    const remove = async(item) => {
        if (!confirm("해당 분류를 삭제하시겠습니까?" )) {
            // 취소(아니오) 버튼 클릭 시 이벤트
        return false;
        } 
        else {
            // 확인(예) 버튼 클릭 시 이벤트
            let params = {
                seq : item,
            }
            let result = await deleteBoardCatList(params);
            if(result.data){
                alert("삭제되었습니다.");
                let result = await getBoardCatList(newCatType);
                data.list = result.data;
                data.count = result.length;
                context.emit('refresh');
            }
        }
    }


    onMounted(loadData)


    return{
      save,
      remove,
      dataObject,
      _dataObject,
      data,
      newCatName,
      newCatType,
      ...methods(),
      dataAction: new TableActionClass(data),
    }
  },
}

function methods() {
  var context = {};
  context["getBoardCatList"] = getBoardCatList;
  context["setBoardCatList"] = setBoardCatList;
  context["deleteBoardCatList"] = deleteBoardCatList;

   // 목록
  async function search() {
    let _params = this.data.params
    this.dataAction.execute("getBoardCatList",context,_params);
  }

  // 상세
  async function edit(_seq){
    let BoardCatInfo = await this.dataAction.execute("getBoardCatList",context, _params);
  }
  return {
    search,
    edit,
    }
}

</script>
